/**
 * LEGACY launch helpers for develop-era game dists (assets/index-*.js + iframe).
 * Remove this module when all games are rebuilt to game-launch.js.
 * See docs/ai-engineering/LEGACY_LAUNCH_FLOW.md
 */

/** Open a legacy game URL in a new tab (direct dist, not /play). */
export function openLegacyGameInNewTab(gameUrl: string): void {
    window.open(gameUrl, '_blank', 'noopener,noreferrer');
}

/** Navigate same-tab to a legacy game URL (direct dist, not /play). */
export function openLegacyGameInSameTab(gameUrl: string): void {
    window.location.assign(gameUrl);
}
